import { BaseEntity } from ".";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class GroupEntity extends BaseEntity {
  private _types: any;
  constructor(id: number, props: any, types: any) {
    super(id, props);
    this._dataTypeName = "Group";
    this._types = types;
  }

  async toJson(expanded?: boolean): Promise<Excel.EntityCellValue> {
    const props = this.props;

    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      delete entity.properties["useBasePrice"];
      delete entity.properties["anchored"];
      delete entity.properties["anchorable"];
      delete entity.properties["iconID"];
      delete entity.properties["fittableNonSingleton"];
      // - Group Id
      if (entity.properties.groupID) {
        delete entity.properties.groupID;
      }
      if (props.name.en) {
        entity.properties["name"] = {
          type: Excel.CellValueType.string,
          basicValue: props.name.en,
        };
        entity.text = props.name.en;
      } else {
        entity.properties["name"] = {
          type: Excel.CellValueType.string,
          basicValue: "Unknown group",
        };
        entity.text = "Unknown group";
      }
      if (props.categoryID) {
        entity.properties["category_id"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: props.categoryID,
          numberFormat: "##0",
        };
        delete entity.properties["categoryID"];
      }
      if (this._types !== null && this._types.length && expanded) {
        let type_array: Excel.CellValue[][] = [];
        for (const y of this._types) {
          const entity = await getCachedTypeEntity(y.typeID);
          if (entity) {
            type_array.push([await entity.toJson()]);
          }
        }
        if (type_array.length) {
          entity.properties["types"] = {
            type: Excel.CellValueType.array,
            elements: type_array,
          };
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };
    return entity;
  }
}
